<template>
  <div style="margin-top: 50px">
    <mt-header title="工单列表"> </mt-header>
    <!-- 查询工具栏 -->
    <div class="seach">
      <mt-search
        style="width: 100%; height: 50px"
        v-model="query.queryString"
        @keyup.enter.native="querySubmit"
      ></mt-search>
    </div>
    <!-- 记录列表-->
    <scroll-body
      style="margin-top: 10px"
      :minheight="200"
      :outheight="180"
      :isScroll="true"
      @resize="resize"
    >
      <template slot="content">
        <ul
          class="telitem infinite-list"
          v-infinite-scroll="loadMore"
          infinite-scroll-disabled="loading"
          infinite-scroll-distance="10"
          :style="bodyStyle"
        >
          <li
            v-for="(item, index) in data.psts"
            :key="index"
            class="infinite-list-item"
          >
            <mt-cell
              :title="item.title"
              :label="
                item.pstSource.replace('红网', '') +
                ' ' +
                item.transferUnitName +
                ' ' +
                item.timeIntervalString +
                ' ' +
                appApi.getStatusTransferTitle(item.status)
              "
              is-link
              @click.native="details(item)"
            />
          </li>
        </ul>
      </template>
    </scroll-body>
  </div>
</template>
  
<script>
import ScrollBody from "@/components/ScrollBody.vue";
export default {
  components: {
    ScrollBody,
  },
  beforeRouteLeave(to, from, next) {
    this.saveStore();
    next(); // 继续后续的导航解析过程
  },
  created() {
    this.pstApi.setWindowTitle("单位工单列表");
    this.data.user = this.pstApi.getUserData();
    if (this.$store.state.unitQuery) {
      this.query = this.$store.state.unitQuery.query;
      // this.xpagination = this.$store.state.unitQuery.xpagination;
    }
    this.getPstList(); //读取分页信息
  },
  data() {
    return {
      //数据项
      data: {
        user: "", //用户数据
        psts: [], //舆情信息
      },
      //搜索栏数据
      query: {
        pstType: -1, //类别
        categorys: [], //状态
        queryString: "", //模糊字段
        isSubmit: -1,
      },
      //分页查询参数
      xpagination: {
        totalCount: 1,
        pageSize: 10,
        currentPage: 1,
        totalPages: 1,
      },
      loading: false,
      //
      mouseStatus: {
        current: 0,
        seen: false,
      },
      bodyStyle: {
        overflowY: "auto",
        overflowX: "hidden",
        listStyle: "none",
        height: 420 + "px",
      },
    };
  },
  methods: {
    saveStore() {
      this.$store.commit("setUnitQuery", {
        query: this.query,
        xpagination: this.xpagination,
      });
    },
    //查询方法部分
    querySubmit() {
      this.xpagination.pageNumber = 1;
      this.getPstList();
    },
    getPstList() {
      //保存store
      this.saveStore();
      this.appApi
        .getUnitPstList(
          this.query.pstType,
          this.query.categorys,
          this.query.queryString,
          this.xpagination.currentPage,
          this.xpagination.pageSize,
          this.query.isSubmit
        )
        .then((res) => {
          var data = res.data;
          this.data.psts = data;
          //   console.log(data);
          var pagin = JSON.parse(res.headers.xpagination);
          //console.log(pagin)
          this.xpagination.totalCount = parseInt(pagin.totalCount);
          this.xpagination.pageSize = parseInt(pagin.pageSize);
          this.xpagination.currentPage = parseInt(pagin.currentPage);
          this.xpagination.totalPages = parseInt(pagin.totalPages);
        })
        .catch(() => {
          Toast("读取失败");
        });
    },
    loadMore() {
      // 判断是否到了最大页数，已是最大页数则不继续加载数据
      if (this.xpagination.currentPage >= this.xpagination.totalPages) {
        return;
      }

      this.xpagination.currentPage++;
      this.loading = true;

      this.appApi
        .getUnitPstList(
          this.query.pstType,
          this.query.categorys,
          this.query.queryString,
          this.xpagination.currentPage,
          this.xpagination.pageSize,
          this.query.isSubmit
        )
        .then((res) => {
          this.loading = false;
          let last = res.data;
          if (last) {
            this.data.psts = this.data.psts.concat(last);
          }
          var pagin = JSON.parse(res.headers.xpagination);
          this.xpagination.totalCount = parseInt(pagin.totalCount);
          this.xpagination.pageSize = parseInt(pagin.pageSize);
          this.xpagination.currentPage = parseInt(pagin.currentPage);
          this.xpagination.totalPages = parseInt(pagin.totalPages);
        });
    },
    details(pst) {
      //保存store
      this.saveStore();
      this.$router.push({ name: "HandleDetail", params: { id: pst.id } });
    },
    handle(pst) {
      //保存store
      this.saveStore();
      if (pst.status == 1) {
        this.$router.push({ name: "Reply", params: { id: pst.id } });
      } else if (pst.status == 3) {
        this.$router.push({ name: "Evidence", params: { id: pst.id } });
      }
    },
    getColorTime(row) {
      if (row.timeIntervalString) {
        let timeIntervalString = row.timeIntervalString.replace(/-/g, "");
        var reg1 = /^剩余([76543]{1,1}|[0123456789]{2,})天/;
        var reg2 = /^剩余[2]{1,1}天/;
        var color = "red";
        if (reg1.test(timeIntervalString)) {
          color = "green";
        } else if (reg2.test(timeIntervalString)) {
          color = "orange";
        }

        return `<font color=${color}>${timeIntervalString}</font>`;
      } else {
        return this.Common.dateFormatter(row.lastTime, "yyyy-MM-dd hh:mm");
      }
    },
    //
    enter(index) {
      this.mouseStatus.current = index;
      this.mouseStatus.seen = true;
    },
    leave() {
      this.mouseStatus.current = null;
      this.mouseStatus.seen = true;
    },
    resize(height) {
      this.bodyStyle.height = height - 10 + "px";
    },
  },
};
</script>
  
<style lang="less" scoped>
/deep/.mint-cell {
  min-height: 60px;
}
/deep/.mint-cell-wrapper {
  font-size: 15px;
}
/deep/.mint-cell-value {
  font-size: 12px;
}
</style>